export default "__VITE_ASSET__l734l5JQ__"